import type { AxiosInstance } from 'axios';
import { useAuthStore } from '../../store/auth-store';

export function authInterceptor(api: AxiosInstance): void {
  api.interceptors.request.use((config) => {
    const session = useAuthStore.getState().session;
    if (session) {
      config.headers.Authorization = `Bearer ${session.accessToken}`;
    }
    return config;
  });
}

export function refreshInterceptor(api: AxiosInstance): void {
  let inflight: Promise<boolean> | null = null;
  api.interceptors.response.use(
    (resp) => resp,
    async (error) => {
      const status = error?.response?.status;
      const original = error?.config;
      if (status === 401 && original && !original._retried) {
        original._retried = true;
        // Coalesce parallel 401s into a single refresh attempt.
        if (!inflight) {
          inflight = useAuthStore.getState().refresh().finally(() => {
            inflight = null;
          });
        }
        const ok = await inflight;
        if (ok) {
          const session = useAuthStore.getState().session;
          if (session) {
            original.headers.Authorization = `Bearer ${session.accessToken}`;
          }
          return api.request(original);
        }
        await useAuthStore.getState().logout(true);
      }
      throw error;
    },
  );
}
